// @flow
import _isEqual from 'lodash/isEqual';

import type { ObjectType } from '@types/misc';

import type { Node } from 'react';

type TProps = {
  children?: Node,
  fallback: boolean,
  fallbackComponent?: Node,
  resetOnChanges?: ObjectType
};

type TState = {
  hasError: boolean
};

type TErrorInfo = {
  componentStack: string,
};

class ErrorBoundary extends React.Component<TProps, TState> {
  state = { hasError: false };
  static defaultProps = { fallback: true };

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: TErrorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, info);
  }

  componentDidUpdate(prevProps: TProps) {
    if (
      this.state.hasError &&
      (this.props.resetOnChanges || prevProps.resetOnChanges) &&
      !_isEqual(prevProps.resetOnChanges, this.props.resetOnChanges)
    ) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      if (this.props.fallback) {
        return this.props.fallbackComponent || <h1>Something went wrong.</h1>;
      } else {
        return null;
      }
    }

    return this.props.children || null;
  }
}

export default ErrorBoundary;
